import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Toolbar } from '@mui/material';
import { Sidebar, Topbar, Footer } from './modules';
import { useSidebar } from './modules/sidebar/use-sidebar';

interface MainProps {
  children?: React.ReactNode;
  hideSidebar?: boolean;
}

const MainContiner = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
}));

const Main: React.FC<MainProps> = (props: MainProps) => {
  const { children, hideSidebar } = props;

  const { isLargeDesktop, hasExpand, setHasExpand } = useSidebar();
  return (
    <MainContiner>
      <Topbar />
      <Box sx={{ flex: 1, display: 'flex' }}>
        {!hideSidebar && (
          <Sidebar
            hasExpand={hasExpand}
            setHasExpand={setHasExpand}
            variant={isLargeDesktop ? 'persistent' : 'temporary'}
            sx={{ width: 290 }}
          />
        )}
        <Box
          component="main"
          sx={(theme) => ({
            flex: 1,
            bgcolor: theme.palette.background.default,
            marginLeft:
              hasExpand && isLargeDesktop && !hideSidebar ? 290 : 'auto',
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          })}
        >
          <Toolbar />
          {children}
        </Box>
      </Box>
      <Footer />
    </MainContiner>
  );
};

export const MainWithoutSidebar: React.FC<{ children?: React.ReactNode }> = (
  props
) => {
  return <Main hideSidebar>{props.children}</Main>;
};

export default Main;
